import { call, put, takeLatest } from "redux-saga/effects";
import { downloadPdf, downloadXls } from "util/download";
// import { replace } from "connected-react-router";

// import { NO_TRANSITION } from "constants.js";
import * as depositsMiddleware from "middleware/deposits";
import { types } from "reducers/deposits";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";
import { selectors as sessionSelectors } from "reducers/session";
import { store } from "store";
import { addUtcOffset } from "util/date";
import { goBack } from "connected-react-router";
import { handleError } from "sagas";

const sagas = [
    takeLatest(types.LIST_DEPOSITS_REQUEST, listDepositsRequest),
    takeLatest(types.LIST_HISTORICAL_DEPOSITS_REQUEST, listHistoricalDepositsRequest),
    takeLatest(types.LIST_DEPOSITS_RATES_REQUEST, listDepositsRatesRequest),
    takeLatest(types.NEW_DEPOSIT_SIMULATION_REQUEST, newDepositSimulation),
    takeLatest(types.DEPOSIT_TICKET_CREDENTIAL_REQUEST, listCredentialsGroups),
    takeLatest(types.NEW_DEPOSIT_TICKET_REQUEST, depositRequest),
    takeLatest(types.SIGN_DEPOSIT_TICKET_REQUEST, signDepositTransaction),
    takeLatest(types.CANCEL_AUTORENEWAL_REQUEST, cancelAutorenewalRequest),
    takeLatest(types.DOWNLOAD_DEPOSIT_LIST_REQUEST, downloadDepositLists),
    takeLatest(types.DOWNLOAD_DEPOSIT_REQUEST, downloadDeposit),
    takeLatest(types.CREATE_DEPOSIT_ACCEPT_TERM, acceptTermDeposit),
];

export default sagas;

function* listDepositsRequest() {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: true };
    const response = yield call(depositsMiddleware.listDeposits, params);

    if (response && response.status === 200) {
        if (response?.data?.code === "BAK600W") {
            yield put({
                type: types.LIST_DEPOSITS_FAILURE,
            });
            if (params.active === false) {
                yield put(notificationActions.showNotification(response.data.message, "error", ["deposits"]));
            }
        } else {
            const depositLocalDate = response.data.data.deposits.map((deposit) => ({
                ...deposit,
                dueDate: addUtcOffset(deposit.dueDate),
                openDate: addUtcOffset(deposit.openDate),
            }));

            yield put({
                type: types.LIST_DEPOSITS_SUCCESS,
                ...response.data.data,
                deposits: depositLocalDate,
            });
        }
    }
}

function* listHistoricalDepositsRequest({ filters, formikBag, closeSidebar }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: false };
    try {
        const response = yield call(depositsMiddleware.listHistoricalDeposits, { ...params, filters });

        if (response && response.status === 200) {
            if (response?.data?.code === "BAK600W" && params.active === true) {
                yield put(notificationActions.showNotification(response.data.message, "error", ["deposits"]));
            }
            yield put({
                type: types.LIST_HISTORICAL_DEPOSITS_SUCCESS,
                ...response.data.data,
            });
        } else if (response.type === "W") {
            yield put({
                type: types.LIST_HISTORICAL_DEPOSITS_FAILURE,
            });
            yield put(
                notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["depositsDetails"]),
            );
        }
    } finally {
        if (formikBag) {
            formikBag.setSubmitting(false);
        }
        if (closeSidebar) {
            closeSidebar(false);
        }
    }
}

function* listDepositsRatesRequest({ depositType, currency }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, depositType, currency };

    let rates = [];
    try {
        const response = yield call(depositsMiddleware.listDepositsRates, params);

        if (response && response.status === 200) {
            if (response.data?.code === "COR000I") {
                rates = response.data.data?.rates;
            }
        }
    } catch (error) {
        const message = i18n.get("global.unexpectedError");

        yield put(notificationActions.showNotification(message, "error", ["deposits"]));
    }

    yield put({
        type: types.LIST_DEPOSITS_RATES_SUCCESS,
        rates,
    });
}

function* newDepositSimulation({ newDepositFormValues }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());

    const params = {
        idUser,
        deposit: {
            depositType: newDepositFormValues.depositType,
            amountInvested: newDepositFormValues.investCapital,
            accreditedAccount: {
                productType: newDepositFormValues.debitAccount.productType,
                number: newDepositFormValues.debitAccount.number,
            },
            deadline: newDepositFormValues.termInDays,
            autoRenewal: newDepositFormValues.expirationAction,
        },
    };

    const response = yield call(depositsMiddleware.newDepositSimulation, params);

    try {
        if (response && response.status === 200) {
            const { code } = response.data;
            if (code !== "COR020W") {
                yield put({
                    type: types.NEW_DEPOSIT_SIMULATION_SUCCESS,
                    newDepositData: {
                        depositNumber: response?.data?.data?.deposit?.depositNumber,
                        currency: params.deposit?.depositType?.slice(-3),
                        interest: response?.data?.data?.deposit?.interest,
                        amountTransfered: response?.data?.data?.deposit?.amountTransfered,
                        rate: response?.data?.data?.deposit?.rate,
                        effectiveRate: response?.data?.data?.deposit?.effectiveRate,
                        dueDate: addUtcOffset(response?.data?.data?.deposit?.dueDate),
                        openDate: addUtcOffset(response?.data?.data?.deposit?.openDate),
                        owner: response?.data?.data?.deposit?.owner,
                        nationalIdentifier: response?.data?.data?.deposit?.nationalIdentifier,
                        coreDeadline: response?.data?.data?.deposit?.coreDeadline,

                        retentions: response?.data?.data?.deposit?.retentions,
                        vats: response?.data?.data?.deposit?.vats,
                        profit: response?.data?.data?.deposit?.profit,
                        stamp: response?.data?.data?.deposit?.stamp,
                        jurisdiction: response?.data?.data?.deposit?.jurisdiction,

                        ...params.deposit,
                        accreditedAccount: {
                            productAlias: response?.data?.data?.deposit?.accreditedAccount?.number,
                            ...params.deposit.accreditedAccount,
                        },
                    },
                    depositToken: response.data?.data?.token,
                    idSimulationTransaction: response.data?.idTransaction,
                });
            } else {
                yield put(notificationActions.showNotification(response.data.data.deposit, "error", ["deposits"]));
                yield put({
                    type: types.NEW_DEPOSIT_SIMULATION_FAILURE,
                });
            }
        }
    } catch (error) {
        const _error = {
            ...error,
            data: {
                ...error.data,
                message: error?.data?.data?.message || error?.data?.message,
            },
        };
        yield call(handleError, _error);
    }
}

function* listCredentialsGroups() {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: true, idActivityToRead: "request.deposit.send" };
    const response = yield call(depositsMiddleware.listCredentialsGroups, params);

    if (response && response.status === 200) {
        yield put({
            type: types.DEPOSIT_TICKET_CREDENTIAL_SUCCESS,
            depositRequiredCredentials: response.data.data?.groups[0]?.credentials,
        });
    }
}

function* depositRequest({ newDepositData, credentials }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    let params = {};
    if (newDepositData?.idTransaction) {
        params = { idUser, active: true, ...newDepositData, ...credentials };
    } else {
        const { currency, amountInvested, accreditedAccount } = newDepositData;
        const amount = { currency, quantity: amountInvested };
        const { number: debitAccount } = accreditedAccount;
        params = { idUser, active: true, deposit: newDepositData, amount, debitAccount, ...credentials };
    }

    const response = yield call(depositsMiddleware.depositRequest, params);

    if (response && response.status === 200) {
        const { code, message = i18n.get("global.unexpectedError") } = response.data;

        const ticketStates = {
            COR020W: "INVALID_CREDENTIAL",
            COR023I: "PENDING",
            COR000I: "FINISHED",
        };

        if (response.data.code === "API603W" && response.data?.data?.message) {
            yield put({ type: types.NEW_DEPOSIT_TICKET_ERROR });
            yield put(
                notificationActions.showNotification(response.data?.data?.message, "error", [
                    "deposits",
                    "depositsTicket",
                ]),
            );
            yield put(goBack());
            return;
        }

        if (code && ticketStates[code] === undefined) {
            yield put(notificationActions.showNotification(message, "error", ["deposits", "depositsTicket"]));
            yield put({ type: types.NEW_DEPOSIT_TICKET_ERROR });
            return;
        }

        yield put({
            type: types.NEW_DEPOSIT_TICKET_SUCCESS,
            depositTicket: {
                status: ticketStates[response.data.code],
                ...response.data,
            },
        });
    }
}

function* signDepositTransaction({ signParams }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = {
        idUser,
        active: true,
        idForm: "depositOpening",
        idActivity: "request.deposit.send",
        ...signParams,
    };
    const signResponse = yield call(depositsMiddleware.signDepositTransaction, params);

    if (signResponse && signResponse.status === 200) {
        const { code, ...data } = signResponse.data;
        const ticketStates = {
            COR020W: "INVALID_CREDENTIAL",
            COR023I: "PENDING",
            COR000I: "FINISHED",
        };

        yield put({
            type: types.SIGN_DEPOSIT_TICKET_SUCCESS,
            depositTicket: {
                status: ticketStates[code],
                ...data,
            },
        });
    }
}

function* cancelAutorenewalRequest({ selectedDeposit, formikBag, credentialType }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, ...selectedDeposit };

    const ticketStates = {
        COR020W: "INVALID_CREDENTIAL",
        COR023I: "PENDING",
        COR000I: "FINISHED",
    };

    const response = yield call(depositsMiddleware.cancelAutorenewalRequest, params);
    const { code, data } = response.data;
    // eslint-disable-next-line no-prototype-builtins
    const isForbiden = response.data.data.hasOwnProperty("invalidPassword");

    if (response && response.status === 200) {
        if (response.type === "W") {
            const keys = Object.keys(data);
            const innerMessage = keys.length > 0 ? data[keys[0]] : "";
            yield put(
                notificationActions.showNotification(innerMessage || i18n.get("global.unexpectedError"), "error", [
                    "/deposits/details/cancelRenewal",
                ]),
            );

            if (isForbiden) {
                formikBag.setErrors({
                    credential: i18n.get(
                        credentialType === "password"
                            ? "preferences.password.password.incorrect"
                            : "login.step1.secondFactor.invalid",
                    ),
                });
            }
        }

        if (code === "COR000I") {
            yield put(
                notificationActions.showNotification(i18n.get("activities.request.agreement.finished"), "success", [
                    "/deposits/cancelRenewal/successTransaction/",
                ]),
            );
        }

        yield put({
            type: types.CANCEL_AUTORENEWAL_SUCCESS,
            depositTicket: {
                status: isForbiden ? "FORBIDEN" : ticketStates[response.data.code],
                ...response.data,
            },
        });

        if (formikBag) {
            formikBag.setSubmitting(false);
        }
    }
}

function* downloadDepositLists({ active, filters, format }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const response = yield call(depositsMiddleware.downloadDepositLists, { idUser, active, filters, format });

    if (response.type === "W") {
        yield put({
            type: types.DOWNLOAD_DEPOSIT_LIST_FAILURE,
        });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["account/details"]),
        );
    } else {
        const { content, fileName } = response.data.data;
        if (format === "PDF") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }
        yield put({ type: types.DOWNLOAD_DEPOSIT_LIST_SUCCESS });
    }
}

function* downloadDeposit({ deposit, format, active }) {
    const { type, data } = yield call(depositsMiddleware.downloadDeposit, deposit, format, active);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_DEPOSIT_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["deposits/details"]),
        );
    } else {
        const { content, fileName } = data.data;

        if (format === "pdf") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }

        yield put({ type: types.DOWNLOAD_DEPOSIT_SUCCESS });
    }
}

function* acceptTermDeposit({ idTransaction, category }) {
    const { type } = yield call(depositsMiddleware.acceptTermDeposit, idTransaction, category);

    if (type === "W") {
        yield put({ type: types.CREATE_DEPOSIT_ACCEPT_TERM_FAILURE });
        yield put(notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["cedips"]));
    } else {
        yield put({ type: types.CREATE_DEPOSIT_ACCEPT_TERM_SUCCESS });
    }
}
